module.exports = __webpack_public_path__ + "static/img/mine-avatar.c8c7ba0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mine-avatar.png
// module id = djdm
// module chunks = 0